// extracted by mini-css-extract-plugin
module.exports = {"alert":"BaseAlert_alert_2O74y","content":"BaseAlert_content_3sUPv","icon":"BaseAlert_icon_wk4B9"};